import { render, staticRenderFns } from "./UserEmptyTile.vue?vue&type=template&id=05b2581c&scoped=true&lang=pug&"
import script from "./UserEmptyTile.vue?vue&type=script&lang=js&"
export * from "./UserEmptyTile.vue?vue&type=script&lang=js&"
import style0 from "./UserEmptyTile.vue?vue&type=style&index=0&id=05b2581c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2581c",
  null
  
)

export default component.exports